/* eslint-disable unicorn/filename-case -- TODO rename later */
import React from "react";

import { IstariDigitalLogo } from "../../assets/svg";

function ErrorBoundaryDisplay() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-[#f3f3f3] text-center">
      <div className="mt-4 items-center gap-5">
        <div className="flex items-center justify-center">
          <IstariDigitalLogo height="40px" />
        </div>
        <div className="items-center gap-5 p-8 text-center">
          <div className="h4 mt-8 text-red-500">Oh no! An error has occurred.</div>
          <div className="mt-5 text-center text-base font-medium text-gray-600">
            Looks like we’ve encountered an issue. It has been reported to our team and we will get around to fixing it
            soon.
          </div>
        </div>

        <a href="/">
          <span className="text-center text-base font-medium text-gray-600 underline">Go back to Home Page</span>
        </a>
      </div>
    </div>
  );
}

export default ErrorBoundaryDisplay;
